"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileUploader;

require("core-js/modules/web.dom-collections.iterator.js");

var _FileUploaderModule = _interopRequireDefault(require("../../assets/styles/components/FileUploader.module.scss"));

var _fileupload = _interopRequireDefault(require("../../assets/animations/fileupload.json"));

var _reactLottiePlayer = _interopRequireDefault(require("react-lottie-player"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileUploader(_ref) {
  let {
    hideAnimation = false,
    accept = "*",
    styling = {},
    direction = "vertical"
  } = _ref;
  const inputRef = (0, _react.useRef)(null);
  const [segment, setsegment] = (0, _react.useState)([0, 1]);
  const [file_selected, setfile_selected] = (0, _react.useState)(false);
  const [file_name, setfile_name] = (0, _react.useState)("");

  const activeHoverEffect = () => {
    if (file_selected) {
      return;
    }

    setsegment([1, 30]);
  };

  const removeHoverEffect = () => {
    if (file_selected) {
      return;
    }

    setsegment([30, 1]);
  };

  const changeFile = e => {
    if (e.currentTarget.files[0]) {
      if (e.currentTarget.files[0].name) {
        setfile_name(e.currentTarget.files[0].name);
        setsegment([80, 125]);
        setfile_selected(true);
      }
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: styling,
    className: _FileUploaderModule.default.fileuploader,
    onMouseLeave: () => {
      removeHoverEffect();
    },
    onMouseEnter: () => {
      activeHoverEffect();
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
      htmlFor: "file",
      className: "".concat(direction === "vertical" ? _FileUploaderModule.default.content_vertical : direction === "horizontal" ? _FileUploaderModule.default.content_horizontal : ''),
      children: [!hideAnimation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactLottiePlayer.default, {
        segments: segment,
        loop: false,
        animationData: _fileupload.default,
        play: true,
        style: {
          width: 100,
          height: 100
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(_FileUploaderModule.default.content),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          ref: inputRef,
          id: "file",
          type: "file",
          onChange: e => {
            changeFile(e);
          },
          accept: accept
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "".concat(_FileUploaderModule.default.upload_button, " ").concat((hideAnimation || direction === "horizontal") && _FileUploaderModule.default.upload_button_noMarginTop),
          onClick: () => {
            inputRef.current.click();
          },
          children: "Click to upload"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: _FileUploaderModule.default.maximum_size,
          children: file_name !== "" ? file_name : "Maximum file size 50MB."
        })]
      })]
    })
  });
}